/* istanbul ignore file */

/* eslint-disable @typescript-eslint/no-use-before-define */
import { isObject } from 'common/type-guards';

const keysToDelete = [
  'access_token',
  'expires_in',
  'headers',
  'idToken',
  'idTokens',
  'issued_tokens',
  'maskedValidationChannel',
  'profiles',
  'subjects',
  'token_type'
];

/**
 * Cleans array object of keys keys listed in keysToDelete array
 */
function cleanArray(arry: unknown[]): unknown[] {
  return arry.map(obj => {
    if (Array.isArray(obj)) {
      return cleanArray(obj);
    }

    if (isObject(obj)) {
      return cleanObject(obj);
    }

    return obj;
  });
}

/**
 * Cleans object of keys keys listed in keysToDelete array
 */
function cleanObject(obj: object) {
  const retObj: Record<string, unknown> = {};

  for (const [key, value] of Object.entries(obj)) {
    if (!keysToDelete.includes(key)) {
      if (isObject(value)) {
        retObj[key] = cleanObject(value);
      } else if (Array.isArray(value)) {
        retObj[key] = cleanArray(value);
      } else {
        retObj[key] = value;
      }
    }
  }

  return retObj;
}

/**
 * Returns cloned object with the keys listed in keysToDelete array removed to prevent
 * them from being logged
 * @param {object} data
 * @returns {object}
 */
export function scrubLogs(data = {}) {
  const dataClone: Record<string, unknown> = {};

  for (const [key, value] of Object.entries(data)) {
    if (!keysToDelete.includes(key)) {
      if (Array.isArray(value)) {
        dataClone[key] = cleanArray(value);
      } else if (isObject(value)) {
        dataClone[key] = cleanObject(value);
      } else {
        dataClone[key] = value;
      }
    }
  }

  return dataClone;
}
